import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          关于6789影院的常见疑问解答
        </p>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="flex items-start gap-3 text-sm font-heading font-semibold text-foreground-900 mb-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-7">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}